export default __webpack_public_path__ + "static/media/icon_bandtype_Partway.167f373e.png";